import React from 'react';
import SquareMinusRegular from '../../Icons/SquareMinusRegular';
import SquarePlusRegular from '../../Icons/SquarePlusRegular';
import SquareXmarkRegular from '../../Icons/SquareXmarkRegular';
export default function TreeView(theme) {
    return {
        MuiSimpleTreeView: {
            defaultProps: {
                slots: {
                    expandIcon: ()=>/*#__PURE__*/ React.createElement(SquarePlusRegular, {
                            sx: {
                                width: 20,
                                height: 20
                            }
                        }),
                    collapseIcon: ()=>/*#__PURE__*/ React.createElement(SquareMinusRegular, {
                            sx: {
                                width: 20,
                                height: 20
                            }
                        }),
                    endIcon: ()=>/*#__PURE__*/ React.createElement(SquareXmarkRegular, {
                            sx: {
                                color: 'text.secondary',
                                width: 20,
                                height: 20
                            }
                        })
                }
            }
        },
        MuiTreeItem: {
            styleOverrides: {
                label: {
                    ...theme.typography.body2
                },
                iconContainer: {
                    width: 'auto'
                }
            }
        }
    };
}
